/**
 * AMK Global Mouse Parallax
 * Applies a subtle ±15px/10px parallax to all [data-amk-parallax] elements.
 * Sections opt in by adding data-amk-parallax to their background element.
 * Desktop-only (pointer: fine).
 */
(function () {
  if (!window.matchMedia('(pointer: fine)').matches) return;

  var mpX = 0, mpY = 0;
  var mpTX = 0, mpTY = 0;
  var mpRaf = null;

  function tick() {
    mpRaf = null;
    mpX += (mpTX - mpX) * 0.07;
    mpY += (mpTY - mpY) * 0.07;

    var els = document.querySelectorAll('[data-amk-parallax]');
    for (var i = 0; i < els.length; i++) {
      els[i].style.transform = 'translateZ(0) translate(' + mpX + 'px, ' + (mpY * 0.55) + 'px)';
    }

    if (Math.abs(mpX - mpTX) > 0.05 || Math.abs(mpY - mpTY) > 0.05) {
      mpRaf = requestAnimationFrame(tick);
    }
  }

  window.addEventListener('mousemove', function (e) {
    var cx = window.innerWidth / 2;
    var cy = window.innerHeight / 2;
    mpTX = ((e.clientX - cx) / cx) * 15;
    mpTY = ((e.clientY - cy) / cy) * 10;
    if (!mpRaf) mpRaf = requestAnimationFrame(tick);
  }, { passive: true });
})();
